import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class LoginGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthenticationService,private auth:AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkLogin(url: string): boolean {
    if (!this.authService.isAuthenticated()) { return true; }
    else{
      this.authService.logout();
      this.auth.logout();
      
    }
    // Store the attempted URL for redirecting
  //   this.authService.redirectUrl = url;

  //   // Navigate to the home page with extras if user is authenticated
  //   this.router.navigate(['/dashboard']);
  //   return false;
  // }
}
}
